export enum ReportType { 
    transaction = 'transaction',
    transactionList = 'transactionList',
    cashInventory = 'cashInventory',
    edenred = 'edenred',
    pluxee = 'pluxee',
    upcz = 'upcz',
    posState = 'posState'
}
